import { TFunction } from 'i18next';
import { FormInstance } from 'antd';
import { useBlocker } from 'react-router-dom';

interface UseFormDirtyCheckOptions {
  form: FormInstance;
  t:TFunction;
  enabled?: boolean;
}

/**
 * Custom hook to detect form changes and prompt user before navigation
 * Uses React Router's useBlocker to intercept navigation
 *
 * @param form - Ant Design Form instance
 * @param enabled - Whether to enable the check (default: true)
 */
export function useFormDirtyCheck({
  form,
  t,
  enabled = true
}: UseFormDirtyCheckOptions) {
  // Use useBlocker to intercept navigation
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => {
      // Only block if form is dirty and check is enabled
      if (!enabled || !form.isFieldsTouched()) {
        return false;
      }

      // Check if the navigation is to a different route
      if (currentLocation.pathname !== nextLocation.pathname) {
        // Show confirmation dialog
        const confirmed = window.confirm(
          t('label.formDirtyCheckMessage')
        );

        if (confirmed) {
          return false; // Allow navigation
        } else {
          return true; // Block navigation
        }
      }

      return false;
    }
  );

  return blocker;
}

